<div class="assign">
  <ion-header>
    <ion-toolbar color="light">
      <ion-title>{{'ADAPTER.ASSIGN' | translate}}</ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="adapters-list">
    <ion-list *ngFor="let adapter of adapters">
      <ion-row class="ion-align-items-start">
        <ion-col size="auto" style="color: #000;">
          <ion-row class="ion-text-start ion-text-wrap" (click)="selectAdapter(adapter.mac)">{{adapter.serial}}</ion-row>
          <ion-row class="ion-text-start ion-text-wrap" *ngIf="adapter.pairedMachine">{{adapter.pairedMachine.name}}</ion-row>
        </ion-col>
      </ion-row>
    </ion-list>
  </div>
  <ion-footer  class="footer">
    <ion-button style="margin-top: 5%" [disabled]="disableAssign" *ngIf="selectedAdapter" size="medium" color="primary" (click)="onClickAssign()">{{'ASSIGN' | translate}}</ion-button>
  </ion-footer>
</div>
